import React, { useEffect } from 'react';
import Waiting from '../components/waiting';
import { querystring } from '../utils/helpers';
import { useStores } from '../hooks/use-stores';
import { useNavigate, useParams } from 'react-router-dom';

function TokenSignIn() {
    const { authStore } = useStores();
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) return;
        authStore.exchangeJwtSignin(token).then((result) => {
            let redirect = querystring('redirect') || '/';
            if (!redirect.startsWith('/')) redirect = `/${redirect}`;
            if (result.success) {
                navigate(redirect);
            } else if (result.expired) {
                authStore.setError(result.message, 'emailLogin');
                navigate(`/auth/signin?expired=1&redirect=${encodeURIComponent(redirect)}`);
            } else {
                navigate(`/auth/signin?redirect=${encodeURIComponent(redirect)}`);
            }
        });
    }, [token]);

    return <Waiting waitingActive={true} fullScreen={true} />;
}

export default TokenSignIn;
